import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./en/common.json";
import enErrors from "./en/errors.json";
import enAuth from "./en/auth.json";
import enNav from "./en/nav.json";
import enProfile from "./en/profile.json";
import enConnections from "./en/connections.json";
import enSingleApp from "./en/single-app.json";
import enSyncGroups from "./en/sync-groups.json";
import enJobs from "./en/jobs.json";
import enBilling from "./en/billing.json";
import enOrganizations from "./en/organizations.json";
import enAnalyses from "./en/analyses.json";
import enQvdAnalysis from "./en/qvd-analysis.json";
import enDashboard from "./en/dashboard.json";
import enChangelog from "./en/changelog.json";
import enCapacity from "./en/capacity.json";
import enReloads from "./en/reloads.json";

import ptBRCommon from "./pt-BR/common.json";
import ptBRErrors from "./pt-BR/errors.json";
import ptBRAuth from "./pt-BR/auth.json";
import ptBRNav from "./pt-BR/nav.json";
import ptBRProfile from "./pt-BR/profile.json";
import ptBRConnections from "./pt-BR/connections.json";
import ptBRSingleApp from "./pt-BR/single-app.json";
import ptBRSyncGroups from "./pt-BR/sync-groups.json";
import ptBRJobs from "./pt-BR/jobs.json";
import ptBRBilling from "./pt-BR/billing.json";
import ptBROrganizations from "./pt-BR/organizations.json";
import ptBRAnalyses from "./pt-BR/analyses.json";
import ptBRQvdAnalysis from "./pt-BR/qvd-analysis.json";
import ptBRDashboard from "./pt-BR/dashboard.json";
import ptBRChangelog from "./pt-BR/changelog.json";
import ptBRCapacity from "./pt-BR/capacity.json";
import ptBRReloads from "./pt-BR/reloads.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        errors: enErrors,
        auth: enAuth,
        nav: enNav,
        profile: enProfile,
        connections: enConnections,
        "single-app": enSingleApp,
        "sync-groups": enSyncGroups,
        jobs: enJobs,
        billing: enBilling,
        organizations: enOrganizations,
        analyses: enAnalyses,
        "qvd-analysis": enQvdAnalysis,
        dashboard: enDashboard,
        changelog: enChangelog,
        capacity: enCapacity,
        reloads: enReloads,
      },
      "pt-BR": {
        common: ptBRCommon,
        errors: ptBRErrors,
        auth: ptBRAuth,
        nav: ptBRNav,
        profile: ptBRProfile,
        connections: ptBRConnections,
        "single-app": ptBRSingleApp,
        "sync-groups": ptBRSyncGroups,
        jobs: ptBRJobs,
        billing: ptBRBilling,
        organizations: ptBROrganizations,
        analyses: ptBRAnalyses,
        "qvd-analysis": ptBRQvdAnalysis,
        dashboard: ptBRDashboard,
        changelog: ptBRChangelog,
        capacity: ptBRCapacity,
        reloads: ptBRReloads,
      },
    },
    fallbackLng: "en",
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "senseguard.language",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.language;

export default i18n;
